import { genHash } from "../utils/genHash";

const genNewCell = () => ({
  id : `cell_${genHash(8)}`,
})

const handleAddColAtIdx = ({
  value,
  onChange,
  id,
  defaultColWidth,
  colIdx,
}) => {

  const { data, colWidthConfig } = value;
  let newData = [...data];
  newData = newData.map((row) => {
    let newCellData = [...row.cellData];
    newCellData.splice(colIdx, 0, genNewCell());
    return {
      ...row,
      cellData: newCellData,
    };
  });

  const newColWidthValue = defaultColWidth + "px";
  const newColWidthConfigAsArray = Object.values(colWidthConfig);
  newColWidthConfigAsArray.splice(colIdx, 0, newColWidthValue);
  const newColWidthConfig = newColWidthConfigAsArray
    .map((width, i) => ({
      colId: `col_${i}`,
      width,
    }))
    .reduce((a, b) => ({ ...a, [b.colId]: b.width }), {});

  onChange &&
    onChange(id, { data: newData, colWidthConfig: newColWidthConfig });
};

export const handleAddCol = ({ value, onChange, id, defaultColWidth }) => {
  handleAddColAtIdx({
    value,
    onChange,
    id,
    defaultColWidth,
    colIdx: value.data[0].cellData.length,
  });
};

export const handleDeleteCol = ({ value, colIdx, onChange, id }) => {
  const { data, colWidthConfig } = value;

  let newData = data.map((row) => {
    let newCellData = row.cellData.filter(
      (cell, cellIdx) => colIdx !== cellIdx
    );
    return {
      ...row,
      cellData: newCellData,
    };
  });

  let newColWidthConfig = { ...colWidthConfig };
  delete newColWidthConfig[`col_${colIdx}`];
  // now that we deleted this colIdx from widthconfig. we need to reset all the keys from col_0 to col_<length-1>
  newColWidthConfig = Object.values(newColWidthConfig)
    .map((width, i) => ({
      colId: `col_${i}`,
      width,
    }))
    .reduce((a, b) => ({ ...a, [b.colId]: b.width }), {});

  onChange &&
    onChange(id, { data: newData, colWidthConfig: newColWidthConfig });
};

export const handleDuplicateCol = ({ value, colIdx, onChange, id }) => {
  const { data, colWidthConfig } = value;

  let newData = data.map((row) => {
    let newCellData = [...row.cellData];
    const dataToDuplicate = {
      ...newCellData[colIdx],
      id: `cell_${genHash(8)}`,
    };
    newCellData.splice(colIdx + 1, 0, dataToDuplicate);
    return {
      ...row,
      cellData: newCellData,
    };
  });

  const newColWidthValue = colWidthConfig[`col_${colIdx}`];
  const newColWidthConfigAsArray = Object.values(colWidthConfig);
  newColWidthConfigAsArray.splice(colIdx + 1, 0, newColWidthValue);
  const newColWidthConfig = newColWidthConfigAsArray
    .map((width, i) => ({
      colId: `col_${i}`,
      width,
    }))
    .reduce((a, b) => ({ ...a, [b.colId]: b.width }), {});

  onChange &&
    onChange(id, { data: newData, colWidthConfig: newColWidthConfig });
};

export const handleInsertColAfter = ({ value, colIdx, onChange, id, defaultColWidth }) => {
  handleAddColAtIdx({
    value,
    onChange,
    id,
    defaultColWidth,
    colIdx: colIdx + 1,
  });
};

export const handleInsertColBefore = ({ value, colIdx, onChange, id, defaultColWidth }) => {
  handleAddColAtIdx({
    value,
    onChange,
    id,
    defaultColWidth,
    colIdx,
  });
};

export const handleClearColContent = ({ value, colIdx, onChange, id }) => {
  const { data, colWidthConfig } = value;
  let newData = data.map((row) => {
    let newCellData = [...row.cellData];
    // let cellToClear = newCellData[colIdx];
    // delete cellToClear.value;
    // console.log({cellToClear})

  /**
   * this genNewRow does one very important thing apart from the obvious of clearing the value: 
   * it creates a fresh new row id, which changes the 'react key' of the row being rendered, which
   * ensures the the RTE used within the cell is reinitiated and the previous value in it is cleared.
   * (since RTEs are not controlled components)
   */
    newCellData.splice(colIdx, 1, genNewCell());
    // console.log({newCellData})
    return {
      ...row,
      cellData: newCellData,
    };
  });
  // console.log({newData})

  onChange &&
    onChange(id, { data: newData, colWidthConfig });
};

